import { computed } from '@vue/composition-api'
import useCurrentInstance from './useCurrentInstance'

export default function useMoment () {
  const { vm } = useCurrentInstance()

  // @ts-ignore
  return computed(() => vm.proxy.$moment)
}
